module.exports = __webpack_public_path__ + "static/img/antigravity.1132fe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/programs_icons/antigravity.svg
// module id = jB0c
// module chunks = 1